import { RewardBadge } from '@/shared/ui/RewardBadge'
import { ProgressBar } from '@/shared/ui/ProgressBar'

type AppMenuRewardsCardProps = {
  points: number
  coins: number
  progressPercent?: number | null
  progressLabel?: string | null
}

export function AppMenuRewardsCard({
  points,
  coins,
  progressPercent,
  progressLabel
}: AppMenuRewardsCardProps) {
  return (
    <div className="relative shrink-0 overflow-hidden rounded-t-xl border-t border-gray-100 bg-[#f8f9fa] px-4 py-3">
      <p className="m-0 mb-2.5 text-2xs font-extrabold tracking-wider text-[var(--color-brand)]">
        SUAS RECOMPENSAS
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <RewardBadge type="xp" value={points} variant="inline" />
        <RewardBadge type="coins" value={coins} variant="inline" />
      </div>

      {progressLabel && progressPercent != null && (
        <>
          <p className="mt-2.5 mb-1.5 max-w-[calc(100%-90px)] text-xs font-semibold text-gray-700">
            {progressLabel}
          </p>
          <ProgressBar value={progressPercent} variant="primary" size="sm" />
        </>
      )}

      <img
        src="/journeys/backpack.png"
        alt=""
        aria-hidden
        className="pointer-events-none absolute right-2 bottom-0 h-16 w-16 object-contain opacity-90"
      />
    </div>
  )
}
